import { useHistory } from 'react-router-dom';
import { useCallback } from 'react';

export const useRedirect = () => {
  const history = useHistory();

  return useCallback((path: string) => () => history.push(path), [history]);

}